import { Flex, Text, Image } from "@chakra-ui/react";
import { Squiggle170x10Icon } from "../../components/icons/Squiggle170x10Icon";
import { useMobileBreakpoint } from "../../utils/useBreakpoints";

export function WhoIsValkyrae() {
  const isMobileBreakpoint = useMobileBreakpoint();
  return (
    <Flex flexDirection="column" gap="24px" alignItems="center" width="100%">
      <Text
        as="h2"
        variant="landingPageSectionTitle"
        textAlign="center"
        id="valkyrae-intro"
      >
        Hihihi!! it's Valkyrae here.
      </Text>
      <Squiggle170x10Icon width="172px" height="12px" color="blaze.blaze" />
      <Text
        textAlign="center"
        fontFamily="Roboto"
        fontSize={isMobileBreakpoint ? "16px" : "18px"}
        lineHeight="150%"
        fontWeight="500"
        color="dune.600"
      >
        Here is my personal corner of the comic world! It has stories from Hihi
        Studios {isMobileBreakpoint ? "" : <br />} as well as some stories I
        love and hope you will too!
      </Text>
      <Image
        src={`${window.gc.global.assets_url}/static/images/web-ui/valkyrae/rae_sig_v2.svg`}
        width="140px"
        height="auto"
        alt="Valkyrae's signature"
      />
    </Flex>
  );
}
